import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { StagedProductsStore } from './stagedProducts/stagedProducts.types';
import { createStagedProductsActions } from './stagedProducts/stagedProducts.actions';

export const useStagedProductsStore = create<StagedProductsStore>()(
  devtools(
    (set, get) => ({
      // Initial state
      stagedProducts: [],
      editingNotesId: null,
      isCommitting: false,

      // Actions
      ...createStagedProductsActions(set, get),
    }),
    {
      name: 'staged-products-store',
    }
  )
);

